module.exports = __webpack_public_path__ + "static/media/arrow.3e4771de.svg";